import { render } from "./UpdateProfileForm.vue?vue&type=template&id=21f5b38a&scoped=true"
import script from "./UpdateProfileForm.vue?vue&type=script&lang=js"
export * from "./UpdateProfileForm.vue?vue&type=script&lang=js"

import "./UpdateProfileForm.vue?vue&type=style&index=0&id=21f5b38a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f5b38a"]])

export default __exports__